import { FC, useEffect, useState } from "react";
import { PlayerMainInfoWidget } from "../../widgets/player/PlayerMainInfo";
import { PlayerExtendedInfoWidget } from "../../widgets/player/PlayerExtendedInfo";
import { getPlayerInfo } from "../../api/transport/playersTransport";
import { PersonBio } from "../../components/player/PersonBio";
import { PlayerDto } from "../../types/player";
import { SiteType, TeamContext } from "../../types/common";
import { PlayerNewsWidget } from "../../widgets/player/PlayerNews";
import { Loader } from "../../components/Loader";
import { getSiteByTeamCode, getTeamNameByCode, setDocumentTitle } from "../../utils";

interface PlayerProfilePageProps {
    playerId: string;
    teamContext?: TeamContext;
    tournamentId?: number;
    seasonId?: number;
    teamId?: number;
}

export const PlayerProfilePage: FC<PlayerProfilePageProps> = ({
    playerId,
    teamContext,
    teamId,
}) => {
    const [playerData, setPlayerData] = useState<PlayerDto | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!playerId) {
            return;
        }

        setLoading(true);
        getPlayerInfo(playerId, teamContext).then((data: PlayerDto) => {
            setPlayerData(data);
            setDocumentTitle(`${data.name} - Игроки - ${getTeamNameByCode(teamContext)} - Официальный сайт ${getSiteByTeamCode(teamContext) === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
        }).finally(() => {
            setLoading(false);
        });
    }, [playerId, teamContext]);

    let content = null;


    if (loading) {
        content = <Loader />;
    } else {
        content = (
            <>
                <PlayerMainInfoWidget
                    playerData={playerData}
                    loading={loading}
                />
                <div className="w-full max-w-[1024px] mx-auto flex flex-col gap-2">
                    <PersonBio
                        title="Биография"
                        content={playerData?.bio}
                    />
                    <PlayerExtendedInfoWidget
                        playerId={playerId}
                        playerData={playerData}
                        teamContext={teamContext}
                        teamId={teamId}
                    />
                </div>
                <PlayerNewsWidget playerId={playerId} />
            </>
        );
    }

    return (
        <div className="flex flex-col items-center gap-4 sm:gap-8 w-full min-h-[500px] pb-8 bg-white">
            {content}
        </div>
    );
}